import axios from "../../util/axios";

export default {
    /**查询关键字*/
    queryGroupKeyWordList: (data) => axios.get({url: "/wx/quotation/keyWord/queryGroupKeyWordList", data}),
    /**保存关键字*/
    saveKeyWord: (data) => axios.post({url: "/wx/quotation/keyWord/saveKeyWord", data}),
    /**删除关键字*/
    deleteKeyWord: (id) => axios.del({url: "/wx/quotation/keyWord/deleteKeyWord", data: {id}}),
}